/**
* @name: img-file
* @author: weiyong
* @date: 2024-03-23 17:04
* @description：img-file
* @update: 2024-03-23 17:04
*/
<template>
  <div class="file-show-item img-file">
     <file-show-item  @downFile="downFile"
                      @remove="handleRemove"
                      @preview="setVisible(true)"
                     :fileAclInfo="fileAclInfo" :fileItem="fileItem"/>
    <a-image
      v-if="visible"
      :width="200"
      :style="{ display: 'none' }"
      :preview="{
        visible,
        onVisibleChange: setVisible,
      }"
      :src="imageSrc"
      @error="previewError"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "img-file",
});
</script>

<script lang="ts" setup>
import {Image as AImage} from 'ant-design-vue';
import FileShowItem from "@/components/xmFileComCtl/coms/file-show-item.vue";
import GoingUtils from '/@/utils/goingUtils';
interface Props {
  fileAclInfo:any,
  fileItem:any,
}

const props = withDefaults(defineProps<Props>(), {
  fileAclInfo:{},
  fileItem:{}
});
const {fileItem}=toRefs(props);

const emit = defineEmits<{
  (event: "preview", value: any): void;
  (event: "remove", value: any): void;
  (event: "downFile", value: any): void;
}>();

const getImgSrc=function (fileItem){
  if(fileItem.id&&(fileItem.id+'').indexOf("/api")>=0){
    return unref(fileItem).id;
  }
  return '/api/pe-attachment/attachment/showImg/' + unref(fileItem).id;
}

const visible = ref<boolean>(false);
const imageSrc=computed(()=>{
  return getImgSrc(fileItem);
})
const setVisible = (value): void => {
  visible.value = value;
};
// 下载
const downFile = (fileItem) => {
  emit("downFile", fileItem);
};

// 删除
const handleRemove = (fileItem) => {
  emit("remove", fileItem);
};

// 预览失败
const previewError = (e) => {
  console.log('图片加载失败---------', e?.target?.currentSrc);
  GoingUtils.showErrorMessage('图片加载失败！');
};
</script>

<style type="text/css" lang="less">
.file-show-item.img-file{
  max-height:55px;
}
</style>
